import axios from "axios";
import {v4 as uuid} from "uuid";


class AthnAuth {
    _idTokenNoAuth = "eyJraWQiOiJvMjdIRGZTVlFoWTFKRnlYTXhvTjJEYWlDNytxbHZvaEJNblpoZlhvSlE0PSIsImFsZyI6IlJTMjU2In0.eyJhdF9oYXNoIjoiTnY3WkxONG5yX29sT0RNeXFTbVQtQSIsInN1YiI6IjdmMGY2Y2RmLWYxNjItNDhjYi05OTJhLWIxMWZkNjZiZTkwMyIsImN1c3RvbTpjb2RpY2Vfc3RydXR0dXJhIjoibG9jYWwiLCJhcG1zOnJ1b2xvX29yZyI6IiIsImN1c3RvbTpjb2RpY2VfZmlzY2FsZSI6ImZyaWZkbmFzZmVlZmFzYXMiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuZXUtY2VudHJhbC0xLmFtYXpvbmF3cy5jb21cL2V1LWNlbnRyYWwtMV9IRktlSk52am4iLCJjb2duaXRvOnVzZXJuYW1lIjoiZnJpZmRuYXNmZWVmYXNhcyIsImdpdmVuX25hbWUiOiJGZXJkaW5hbmRvIiwiYXVkIjoiMTd1ZjM0cHRqczQyMjlhOTc0YjBwYW1xb2ciLCJldmVudF9pZCI6IjEyYWZkNmFkLWM0Y2UtNDI2NC1iYWZkLTI3MTA5OTVjMThiNCIsInRva2VuX3VzZSI6ImlkIiwiYXBtczpzY2FkZW56YV9wd2QiOiJXZWQgRGVjIDAyIDIwMjAgMTE6MTg6MDMgR01UKzAwMDAgKENvb3JkaW5hdGVkIFVuaXZlcnNhbCBUaW1lKSIsImF1dGhfdGltZSI6MTYxNTk3OTIyOCwiYXBtczpncnVwcGkiOiJvcF9yZWciLCJjdXN0b206YXBtczpjb2RpY2VfZmlzY2FsZSI6IkZSSUZETkFTRkVFRkFTQVMiLCJleHAiOjE2MTU5ODI4MjgsImlhdCI6MTYxNTk3OTIyOCwiZmFtaWx5X25hbWUiOiJGaW9yZSIsImVtYWlsIjoiZmVyZGluYW5kby5maW9yZUBkeGMuY29tIn0.C1yQTCj-pRiKgSv-klAaXItMw04SBbAie8giDXISwqXDIk9eaNxkWm3YLLhBS8foKTryVP-rhQ37pn9prslNH2__sW0NFQjXViWxmx9AvsApsJ5Prex3iHnVD6eqesm0CG_cRyAUMsjc3xdnbFc21htT5EkxmcZQ8WiQ_SR1TPydEp94bwzINsdg8_p_1b-tc7ckpykLxMI23Vc_KMr_5Yk4eYc2mAvyKEFo0ECUqljZR3wYz6sXXSflC5D82VQ0it4tNfEWknZa2VZ79XmbPBRRioOuwmMZUmk-wgG18irYfHb9CjTNcg0OeL8U8pJKkRhVBlcf04rNnNSCFmigrg";
    _samlTokenNoAuth = "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";
    _timeoutRigenerazioneToken = 2700000;
    _timeoutSessionInactivity = 3600000;
    _timeoutSession = 28800000;
    _timeoutRigenerazioneSamlToken = 13500000;

    _idToken = null;
    _testaRefreshToken = null;
    _sessionId = null;
    _samlToken = null;

    _httpClient = null;

    utente = {
        nome: null,
        cognome: null,
        codiceFiscale: null,
        codiceStruttura: null,
        gruppi: null,
        strutturaHiv: null,
    };

    contesto = null;

    constructor() {
        axios.interceptors.request.use(
            request => {
                return this._interceptor(request)
            },
            error => {
                return error
            }
        );

        this._httpClient = axios.create({
            timeout: 10000,
            responseType: 'json'
        });
    }

    _makeid = (length) => {
        var result = ''
        var characters = 'abcdef0123456789'
        var charactersLength = characters.length
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength))
        }
        return result
    }

    _interceptor(request) {
        if (request.url !== this._urlAthnTokens &&
            request.url !== this._urlAthnRefreshToken &&
            request.url !== this._urlAthnSamlToken) {
            if (this._loggedin) {
                request.headers['AZContext'] = `sessionid=${this._sessionId};applicationid=${this._applicationId};operationid=${this._makeid(16)};contesto=${this.contesto}`;
                if (this._auth) {
                    request.headers['Authorization'] = `Bearer ${this._idToken}`;
                } else {
                    request.headers['AZUser'] = `id=${this.utente.codiceFiscale};name=${this.utente.nome};surname=${this.utente.cognome};authenticationinfo=localtest;roles=${this.utente.gruppi}`;
                }

                if (this._samlTokenResources.find((item) => {
                    return request.url.includes(item);
                })) {
                        let url = request.url.concat("&authrve1b=" + this._samlToken.toString());
                        request.url = url;
                    }

                clearTimeout(this._sessionInactivityTimeout);
                this._sessionInactivityTimeout = setTimeout(this._logout, this._timeoutSessionInactivity, this);
            } else {
                this.login();
            }
        }

        return request
    }

    _generazioneCodeVerifier() {
        const randomItems = new Uint32Array(128);
        window.crypto.getRandomValues(randomItems);
        const binaryStringItems = randomItems.map(dec => `0${dec.toString(16).substr(-2)}`)
        return binaryStringItems.reduce((acc, item) => `${acc}${item}`, '');
    }

    async _generazioneCodeChallange(codeVerifier) {
        const digest = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(codeVerifier));
        const stringifiedArrayHash = new Uint8Array(digest).reduce((acc, i) => `${acc}${String.fromCharCode(i)}`, '');
        return btoa(stringifiedArrayHash).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }

    _parseJwt(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    async _rigenerazioneToken(instance) {
        if (instance._auth) {
            let res = await instance._httpClient.post(instance._urlAthnRefreshToken, {
                sessioneUtente: {
                    sessionId: instance._sessionId,
                    testaRefreshToken: instance._testaRefreshToken
                }
            }, {withCredentials: true});
            instance._idToken = res.data.idToken;
            instance._testaRefreshToken = res.data.testaRefreshToken;
        } else {
            console.log("Rigenerazione token");
        }
    }

    async _generazioneSamlToken(instance) {
        try {
            if (instance._auth) {
                let res = await instance._httpClient.post(instance._urlAthnSamlToken, {sessionId: instance._sessionId}, {withCredentials: true});
                instance._samlToken = res.data.samlToken;
            } else {
                instance._samlToken = instance._samlTokenNoAuth;
            }

            if (!instance._refreshSamlTokenTimeout) {
                instance._refreshSamlTokenTimeout = setInterval(instance._generazioneSamlToken, instance._timeoutRigenerazioneSamlToken, instance);
            }
        } catch (error) {
            let errorCode = error.response && error.response.data &&  error.response.data.ErrorCode?error.response.data.ErrorCode:""
            let description = error.response && error.response.data && error.response.data.Description?error.response.data.Description:""
            this._samlTokenErrorFunction(errorCode, description);
        }
    }

    async _loginCallback() {
        var urlParams = JSON.parse('{"' + decodeURI(window.location.search).substring(1)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') + '"}');

        let currentState = localStorage.getItem("state");
        if (currentState === urlParams.state) {
            if (this._auth) {
                let res = await this._httpClient.post(this._urlAthnTokens, {
                    authorizationCode: urlParams.code,
                    codeVerifier: localStorage.getItem("code_verifier")
                }, {withCredentials: true});
                this._idToken = res.data.idToken;
                this._testaRefreshToken = res.data.testaRefreshToken;
                this._sessionId = res.data.sessionId;
            } else {
                this._idToken = this._idTokenNoAuth;
                this._sessionId = uuid();
            }

            let idToken = this._parseJwt(this._idToken);
            this.utente.nome = idToken.given_name;
            this.utente.cognome = idToken.family_name;
            this.utente.codiceFiscale = idToken["custom:codice_fiscale"];
            this.utente.codiceStruttura = idToken["custom:codice_struttura"];
            this.utente.gruppi = idToken["apms:gruppi"];
            this.utente.strutturahiv = idToken["apms:SIRMI-HIV-STRUTTURA"] ? idToken["apms:SIRMI-HIV-STRUTTURA"] : "";

            this._refreshTimeout = setInterval(this._rigenerazioneToken, this._timeoutRigenerazioneToken, this);
            this._sessionInactivityTimeout = setTimeout(this._logout, this._timeoutSessionInactivity, this);
            this._sessionTimeout = setTimeout(this._logout, this._timeoutSession, this);

            //riabilitare la chiamata per la generazione del saml token appena si renderà necessario utilizzare un servizio infrastrutturale (esempio A2 o FSER)
            this._generazioneSamlToken(this);

            this._loggedin = true;
        }

        return this.utente;
    }

    configurazione(config) {
        this._auth = config.auth;
        this._applicationId = config.applicationId;
        this._urlAthn = config.urlAthn;
        this._samlTokenErrorFunction = config.samlTokenErrorFunction;
        this._samlTokenResources = config.samlTokenResources;

        this._urlAthnLogin = `${this._urlAthn}/login`;
        this._urlAthnLogout = `${this._urlAthn}/logout`;
        this._urlAthnTokens = `${this._urlAthn}/tokens`;
        this._urlAthnRefreshToken = `${this._urlAthn}/refreshtoken`;
        this._urlAthnSamlToken = `${this._urlAthn}/samltoken`;
    }

    async login() {
        let state = uuid();
        localStorage.setItem("state", state);
        let codeVerifier = this._generazioneCodeVerifier();
        localStorage.setItem("code_verifier", codeVerifier);
        let codeChallenge = await this._generazioneCodeChallange(codeVerifier);

        if (this._auth) {
            window.location.href = `${this._urlAthnLogin}?state=${state}&codeChallenge=${codeChallenge}`;
        } else {
            window.location.href = `login-callback?state=${state}`;
        }
    }

    async recuperoSessione(samlTokenErrorCallback) {
        if (window.location.pathname === "/login-callback") {
            //recupero token
            return this._loginCallback(samlTokenErrorCallback);
        } else if (window.location.pathname === "/logout-callback") {
            //cancellazione sessione
        } else if (window.location.pathname === "/logout") {
            this.logout()
        } else {
            //login
            this.login();
        }
    }

    _logout(instance) {
        console.log(`auth: ${instance._auth}`);
        console.log(`auth: ${instance._idToken}`);
        clearInterval(instance._refreshTimeout);
        clearInterval(instance._refreshSamlTokenTimeout);
        clearTimeout(instance._sessionTimeout);
        clearTimeout(instance._sessionInactivityTimeout);

        instance._idToken = null;
        instance._samlToken = null;
        instance._testaRefreshToken = null;
        instance._sessionId = null;

        instance._loggedin = false;

        if (instance._auth) {
            window.location.href = `${instance._urlAthnLogout}`
        } else {
            window.location.href = "logout-callback";
        }
    }

    logout() {
        localStorage.removeItem("state");
        localStorage.removeItem("code_verifier");
        sessionStorage.clear();
        this._logout(this);
    }
}

const auth = new AthnAuth();

export default auth;